module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAZlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+Vn2moAAAAIXRSTlMA7LgmGfnx493RrZ49FQ4LBQPNfnhaLMm9s5iUkF9VQy9gO/HfAAAAiElEQVQoz82ORxLCMAxFZbklTpye0Mu//yWZCWRkCMMCNryV9FTpF9rDsX3n6x0Q6rU3HZzDJr76ycNPV49MP/uLQ2eITA5Vpv5kwfP6imFH8T2wfzzUFEBPEg/SNQBFM09vYc+UMFpwJfcSSoXcUFDLh4LOVCDNkVZEvjcDi5HsHwopnwpfcQPZPA3Oz9Ks9gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zy2.png
// module id = 461
// module chunks = 0 1 2 3 4 5 6 7